import React from 'react';
import PropTypes from 'prop-types';

const Like = props => {
  const { color, width, height, ...other } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" {...other}>
      <rect id="bound" width="24" height="24" fill="none" />
      <path id="Path-42" d="M9,10v9l1.153.384A12,12,0,0,0,13.947,20h3.593a3,3,0,0,0,2.942-2.412l.749-3.746a3,3,0,0,0-3.141-3.582L14.5,10.5l.364-4.006a1.37,1.37,0,0,0-1.24-1.488Q13.562,5,13.5,5h0a2.649,2.649,0,0,0-2.272,1.286Z" fill={color} fillRule="evenodd" />
      <rect id="Rectangle-153" width="5" height="11" rx="1" transform="translate(2 9)" fill={color} opacity="0.3" />
    </svg>
  );
}

Like.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

Like.defaultProps = {
  color: '#FFFFFF',
  width: 20,
  height: 20,
};

export default Like;



// WEBPACK FOOTER //
// ./src/components/Icons/Like.jsx